import type { Route } from "./+types/navigation.layout";

import { Outlet, data } from "react-router";

import Footer from "../components/footer";
import { NavigationBar } from "../components/navigation-bar";
import { getAuthContext } from "../lib/auth-context.server";

export async function loader({ request }: Route.LoaderArgs) {
  const ctx = await getAuthContext(request);
  return data(
    { user: ctx.user, role: ctx.role },
    { headers: ctx.headers },
  );
}

export default function NavigationLayout({ loaderData }: Route.ComponentProps) {
  const { user, role } = loaderData;
  return (
    <div className="flex min-h-screen flex-col justify-between">
      {user === null ? (
        <NavigationBar loading={false} />
      ) : (
        <NavigationBar
          name={user.user_metadata.name || "Anonymous"}
          email={user.email}
          avatarUrl={user.user_metadata.avatar_url}
          loading={false}
          isAdmin={role === "admin"}
        />
      )}
      <div className="mx-auto my-8 w-full max-w-screen-2xl px-5 md:my-12">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
